import { Component, OnInit, Input, EventEmitter, OnChanges, SimpleChanges, ViewChild, Output } from '@angular/core';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, debounceTime, switchMap } from 'rxjs/operators';
import { ApplicationControlService } from '../../services/applicationcontrol.service';
import { CSEService } from '../../services/cse.service';
import { APIResponse, CarrierLookup } from '../../models/models';

@Component({
    selector: 'carrier-dropdown',
    templateUrl: './carrier-dropdown.component.html',
    standalone: false
})
export class CarrierDropdown implements OnInit, OnChanges {
    @Input() parentForm: UntypedFormGroup = new UntypedFormGroup({});
    @Input() ctrlName: string = "carrierLookupCtrl";
    @Input() carrierID: number = 0;
    @Input() placeholder: string = "Select";
    @Input() isChooseFirstCarrier: boolean = false;
    @Input() carrierLookupType: string = "Code";
    @Input() isDisabled: boolean = false;
    @Input() isRequired: boolean = false;
    @Input() defaultCarrier: string = "";

    @Output() carrierSelected = new EventEmitter<any>();
    @Output() carrierBlurred = new EventEmitter<any>();

    @ViewChild('autoTrigger', { static: false, read: MatAutocompleteTrigger }) autoTrigger!: MatAutocompleteTrigger;
    @ViewChild('carrier', { static: false }) carrier!: MatAutocomplete;

    //public carriers: CarrierLookup[] = [];
    public carriersStartsWith: Array<string> = [];
    public filteredResponse: Observable<APIResponse> = new Observable<APIResponse>();
    public filteredCarriers: CarrierLookup[] = [];
    public selectedCarrierID: number = 0;
    public displayValue: string = "";
    public ariaLabel: string = "";
    public isError: boolean = false;
    public errorDetail: string = "";
    public isKendo: boolean = false;

    constructor(private applicationControlService: ApplicationControlService, private cseService: CSEService) { }

    ngOnInit() {
        this.applicationControlService.getApplicationControlsByAppName('UITypeaheadSource', false).subscribe(result => {
            if (result.length > 0) {
                this.isKendo = result[0].appSettingValue == "kendo";
            }
        });
        this.ariaLabel = this.placeholder;
        this.errorDetail = "Please " + this.placeholder.toLowerCase();
        //this.getCarriers();
        if (this.defaultCarrier != "") {
            this.placeholder = this.defaultCarrier;
            this.parentForm!.controls[this.ctrlName].setValue(this.defaultCarrier);
        }
        else {
        }
        this.filteredResponse = this.parentForm!.controls[this.ctrlName].valueChanges.pipe(
            startWith(''),
            debounceTime(300),
            switchMap(carrier => carrier ? this.filterCarriers(carrier) : new Array())
        );
        this.filteredResponse.subscribe(result => {
            this.filteredCarriers = result.resultCollection;
            //console.log("filteredCarriers", this.filteredCarriers);
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        var ok = changes;

        if (this.defaultCarrier != "") {
            this.placeholder = this.defaultCarrier;
            this.parentForm!.controls[this.ctrlName].setValue(this.defaultCarrier);
        }

        if (changes.carrierId == null || changes.carrierId.currentValue == null) return;

        this.selectedCarrierID = parseInt(changes.carrierId.currentValue);
    }

    private filterCarriers(value: string) {
        if (typeof value !== 'string') return new Array();
        const filterValue = value.toLowerCase();
        if (filterValue.length < 3) return new Array();
        //if (this.carriersStartsWith.indexOf(filterValue) > -1) {
        //    // Get cached data
        //    return 
        //}
        //return this.cseService.getAllSearchCarrierLookup(value);
        //console.log("filterCarriers", this.carrierLookupType, value);
        return this.cseService.getAllSearchCarrierLookup(this.carrierLookupType, value);
        //return this.getCarrierLookupList(value);

        //if (this.carrierLookupType == "Code") {
        //    this.getCarrierLookupList(selectedCarrier.carrierCode);
        //}
        //else if (this.carrierLookupType == "Name") {
        //    this.getCarrierLookupList(selectedCarrier.name);
        //}
        //else if (this.carrierLookupType == "MC") {
        //    this.getCarrierLookupList(selectedCarrier.mcNumber);
        //}
        //else if (this.carrierLookupType == "DOT") {
        //    this.getCarrierLookupList(selectedCarrier.dotNumber!.toString());
        //}
        //else if (this.carrierLookupType == "MC") {
        //    this.getCarrierLookupList(selectedCarrier.mcNumber);
        //}
        //else if (this.carrierLookupType == "SCAC") {
        //    this.getCarrierLookupList(selectedCarrier.scacCode);
        //}
        //return this.cseService.getAllSearchCarrierLookup(type, value);
    }

    public getCarrierLookup(value: string) {
        //console.log("filterCustomers", value);
        if (value.length < 3) {
            this.filteredCarriers = [];
            return;
        }

        this.cseService.getAllSearchCarrierLookup(this.carrierLookupType, value).subscribe(result => {
            var lst: CarrierLookup[] = result.resultCollection;
            lst = lst.sort((left, right): number => {
                if (left.carrierCode < right.carrierCode) return -1;
                if (left.carrierCode > right.carrierCode) return 1;
                return 0;
            });
            this.filteredCarriers = lst;
        });
    }

    private getCarrierLookupList(value: string) {
        //this.isLoading = true;
        //console.log("getCarrierLookupList", this.carrierLookupType, value);
        return this.cseService.getAllSearchCarrierLookup(this.carrierLookupType, value);
        //return this.cseService.getAllSearchCarrierLookup(this.carrierLookupType, value).subscribe(result => {
        //    //this.isLoading = false;
        //    this.carriers = result.resultCollection;
        //});
    }

    public chooseActiveCarrier(event: any) {
        if (this.autoTrigger.activeOption) {
            this.parentForm!.controls[this.ctrlName].setValue(this.autoTrigger.activeOption.value);
            this.optionChanged(event);
            return;
        } else if (this.autoTrigger.autocomplete.options.first) {
            this.parentForm!.controls[this.ctrlName].setValue(this.autoTrigger.autocomplete.options.first.value);
            this.optionChanged(this.autoTrigger.autocomplete.options.first.value);
            //console.log("choseActiveCarrier", this.autoTrigger.autocomplete.options.first.value);
        }
        if (this.isChooseFirstCarrier != true || this.carrier.options.length < 1) return;

        this.parentForm!.controls[this.ctrlName].setValue(this.carrier.options.first.value);
    }

    public optionChanged(evt: any) {
        console.log("optionChanged", evt);
        if (this.isKendo) {
            var idx = this.filteredCarriers.findIndex(t => t.carrierCode == evt);
            //console.log("optionChanged", idx);
            if (idx >= 0) {
                console.log("optionChanged", this.filteredCarriers[idx]);
                this.carrierSelected.emit(this.filteredCarriers[idx].carrierID);
            }
        }
        else {
            if (evt.option) {
                this.carrierSelected.emit(evt.option.value);
            }
            else if (evt.carrierID) {
                this.carrierSelected.emit(evt);
            }
            else {
                this.carrierSelected.emit(0);
            }
        }
        //this.filteredCarriers = new Observable<CarrierLookup[]>();
        this.filteredCarriers = [];
    }

    public optionBlurred() {
        if (this.displayValue == "") {
            this.carrierSelected.emit(0);
        }
        this.carrierBlurred.emit();
    }

    public displayCarrier(carrier?: CarrierLookup): string | undefined {
        var disp = "";
        if (carrier) {
            if (this.carrierLookupType == "Code") {
                disp = carrier!.carrierCode + " - " + carrier!.name;
            }
            else if (this.carrierLookupType == "Name") {
                disp = carrier!.carrierCode + " - " + carrier!.name;
            }
            else if (this.carrierLookupType == "MC") {
                disp = carrier!.mcNumber + " - " + carrier!.name;
            }
            else if (this.carrierLookupType == "DOT") {
                disp = carrier!.dotNumber + " - " + carrier!.name;
            }
            else if (this.carrierLookupType == "MX") {
                disp = carrier!.mcNumber + " - " + carrier!.name;
            }
            else if (this.carrierLookupType == "SCAC") {
                disp = carrier!.scacCode + " - " + carrier!.name;
            }
            else {
                disp = carrier!.carrierCode + " - " + carrier!.name;
            }
        }
        //console.log("displayCarrier", this.carrierLookupType, disp, carrier);
        return disp;
        //return carrier ? (this.isCarrierCode ? carrier.carrierCode : carrier.name) : undefined;
        //return carrier ? carrier.carrierStateZip : undefined;
    }

    public isValid() {
        return this.parentForm!.controls[this.ctrlName].hasError('required');
    }
}